import React, { memo } from 'react'
import { string, any } from 'prop-types'
import { Tooltip } from 'components'
import classnames from 'classnames'
import { StyledClickableIcon } from './ClickableIcon.style'

function ClickableIcon({ icon, label, className, tooltip, disabled, ...props }) {
  const widget = (
    <StyledClickableIcon className={classnames(className, { disabled })}{...props}>
      {icon}
      {label && <span className="ml-2">{label}</span>}
    </StyledClickableIcon>
  )

  return tooltip ? <Tooltip text={tooltip}>{widget}< /Tooltip> : widget
}

ClickableIcon.propTypes = {
  label: string,
  icon: any.isRequired,
}

export default memo(ClickableIcon)
